// extracted by mini-css-extract-plugin
module.exports = {"language-select":"language-select-module--language-select--xpSIM","lang":"language-select-module--lang--FKGbk","lang--selected":"language-select-module--lang--selected--3pLq1"};